import React, { Component } from "react";
import MarketplaceHeader from '../home/MarketplaceHeader';
import SessionMenu from '../home/SessionMenu';
import MarketplaceLive from '../home/MarketplaceLive';
import MarketplaceOnDemand from '../home/MarketplaceOnDemand';
import MarketplacePrograms from '../home/MarketplacePrograms';
import MarketplaceChallenges from '../home/MarketplaceChallenges';
import MarketplaceMySchedule from '../home/MarketplaceMySchedule';
import MarketplaceMyProfile from '../home/MarketplaceMyProfile';
import MainLoader from '../home/MainLoader';
import LoggedUser from '../home/LoggedUser';
import SupportContainer from '../home/SupportContainer';
import SettingsPage from '../home/SettingsPage';
import { updatesse } from '../../utils/updatesse';
import $ from 'jquery';

import axiosVirdioT from '../../utils/axios';
var axiosVirdio;

class MarketplaceDashboard extends Component {
  
  constructor(props) {
	super(props);
	this.myRefLive = React.createRef();
	this.myRefSchedule = React.createRef();
	this.myRefOnDemand = React.createRef();
	this.myRefPrograms = React.createRef();
	this.myRefChallenges = React.createRef();
	this.myRefProfile = React.createRef();
	this.refMyUser = React.createRef();
	this.refMyMenu = React.createRef();
	this.refSettings = React.createRef();
	
	this.state={
		chosenMenu: 'Classes',
		chosenClassesMenu: ( localStorage.getItem('userData') && JSON.parse(localStorage.getItem('userData')) && JSON.parse(localStorage.getItem('userData')).showLiveAndOnDemand ) ? 'Live' : 'My schedule',
		isOpenDetailedClass: false,
		showLoader: false,
		supportPageName: 'Home',
		supportPageApi: '/home',
		userTypeFaqs: 1,
		currentUserData: localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')) : {},
		openedDemandId: 0,
		openedLiveId: 0,
		openedProgramId: 0,
		openedChallengeId: 0,
		showPaymentsErrorStatus: false,
		failedPaymentStatus: false,
		failedPaymentDetails: [],
		membershipFailedStatus: false,
    }
	this.updatesse = updatesse.bind(this);
}

componentDidMount(){
	document.title = 'Virdio Live Streaming & On-demand';
	
	axiosVirdio = new axiosVirdioT(this.props);
	
	let mainthis = this;
	let currentUserData = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')) : {};
	
	if ( this.state.currentUserData.isMarketplaceUser == 1 && this.state.currentUserData.type != 1 )
		{
			axiosVirdio.post(process.env.REACT_APP_API_URL+"/api/v1/user/checkMemberAvailableStatus",{memberId: this.state.currentUserData.id, email: this.state.currentUserData.email}).then(res => {
				if ( res.data.responseData.planStatus )
					{
						this.setState({
							failedPaymentStatus: false,
						});
					}
				else 
					{
						this.setState({
							failedPaymentStatus: true,
						});
					}					
			}).catch(err =>{
						console.log('-error', err);
					});
		}
	
	
	this.updatesse('marketplaceDashboard', [currentUserData.id], function (data)
		{
			mainthis.updateChilds();
		});
	
	if ( window.location.hash == '#mySchedule' || window.location.hash == '#onDemand' || window.location.hash == '#myScheduleAndBookmark' )
		{
			if ( window.location.hash == '#mySchedule' )
				{
					this.setState({ chosenClassesMenu: 'My schedule'});
				}
				
			if ( window.location.hash == '#onDemand' )
				{
					this.setState({ chosenClassesMenu: 'On-demand'});
				}
			
			if ( window.location.hash == '#myScheduleAndBookmark' )
				{
					this.setState({ chosenClassesMenu: 'My schedule'});
					if ( this && this.myRefSchedule && this.myRefSchedule.current) 
						{ 
							this.myRefSchedule.current.openBookmarks();
						}
				}				
		}
	else
		{
			let localstoragedata = JSON.parse(localStorage.getItem('userData'));
			if ( localstoragedata && localstoragedata.sessionData && localstoragedata.sessionData.id != undefined )
				{
					let joinDuration = localstoragedata.default.streamJoiningDefaultTime * 60000;
					var startDateTime = new Date(new Date(localstoragedata.sessionData.scheduleDate).getTime() - joinDuration);
					var timeLeft = Math.ceil(Math.round( (new Date(startDateTime).getTime() - new Date().getTime()) / 1000 ) / 60 );
					
					if ( timeLeft <= 0 )
						{
							this.setState({ chosenClassesMenu: 'My schedule'});
						}
				}
			if ( this.props.parentComponent && this.props.parentComponent == 'marketplaceglobal' )
				{
					this.setState({ 
						chosenClassesMenu: 'Live'
					}, ()=>{
							console.log('out');
							if ( mainthis && mainthis.myRefLive && mainthis.myRefLive.current) 
								{ 
									console.log('in');
									mainthis.myRefLive.current.getLiveClasses(true, true); 
								}
						});
				}
		}
		
	$('.main_loader').attr({'style':'display:none'});	
}

updateChilds=()=>{
	if ( this.state.currentUserData && this.state.currentUserData.showLiveAndOnDemand )
		{
			if ( this && this.myRefLive && this.myRefLive.current) 
				{ 
					this.myRefLive.current.getLiveClasses(true, true); 
					if ( this.state.isOpenDetailedClass && this.state.chosenClassesMenu == 'Live' )
						{
							this.myRefLive.current.openClassDetails(this.state.openedLiveId);
						}
				}
			
			if ( this && this.myRefOnDemand && this.myRefOnDemand.current) 
				{ 
					this.myRefOnDemand.current.getOnDemandClasses(true, false); 
					if ( this.state.isOpenDetailedClass && this.state.chosenClassesMenu == 'On-demand' )
						{
							this.myRefOnDemand.current.openDetailOnDemand(this.state.openedDemandId);
						}
				}
			
			if ( this && this.myRefPrograms && this.myRefPrograms.current) 
				{ 
					this.myRefPrograms.current.getChallenges(true, false); 
					if ( this.state.isOpenDetailedClass && this.state.chosenClassesMenu == 'Programs' )
						{
							this.myRefPrograms.current.openChallengeDetail(this.state.openedProgramId);
						}
				}
			
			if ( this && this.myRefChallenges && this.myRefChallenges.current) 
				{ 
					this.myRefChallenges.current.getChallenges(true, false); 
					if ( this.state.isOpenDetailedClass && this.state.chosenClassesMenu == 'Challenges' )
						{
							this.myRefChallenges.current.openChallengeDetail(this.state.openedChallengeId);
						}
				}
		}
	if ( this && this.myRefSchedule && this.myRefSchedule.current) 
		{ 
			this.myRefSchedule.current.checkIfOpenedBookmarkTab();
			this.myRefSchedule.current.refreshPage(false);
		}
	if ( this && this.refMyUser && this.refMyUser.current) { this.refMyUser.current.updateUser(); }
	if ( this && this.refMyMenu && this.refMyMenu.current ) { this.refMyMenu.current.updateForTabsSwitch(); }
	
	let mainthis = this;
	setTimeout(function(){
		if ( mainthis && mainthis.myRefSchedule && mainthis.myRefSchedule.current !== null) 
			{
				mainthis.myRefSchedule.current.checkIsLiveTabVisible();
			}
	}, 1000);	
}

updateStateFromChild=(state)=>{
	this.setState(state);

	if ( state['chosenMenu'] )
		{
			this.closeDetails();
		}

	if ( state.chosenMenu && state.chosenMenu == 'My Profile' )
		{
			if ( this && this.myRefProfile && this.myRefProfile.current)
				{
					if ( this.state.currentUserData.isMarketplaceUser == 1 )
						{
							this.myRefProfile.current.getMyStatistics();
						}
				}
		}
		
	if ( state.chosenMenu && state.chosenMenu == 'Settings' )
		{
			if ( this && this.refSettings && this.refSettings.current)
				{
					this.refSettings.current.resetUserInfo();
				}
			
		}		
}

closeDetails=()=>{
	this.setState({isOpenDetailedClass: false});
}

updateAllProfileData = ()=>{
	if ( this && this.myRefProfile && this.myRefProfile.current)
		{
			this.myRefProfile.current.updateUserData();
		}
}

searchFromMySchedule=(mod)=>{
	if ( this && this.myRefLive && this.myRefLive.current )
		{
			this.myRefLive.current.searchFromMySchedule(mod);
		}
}

  render() {
	 return (
		<div className={"" + (this.globalOpen ? 'd-none' : '')}>
			<div className={"marketplace_container " + ( this.state.isOpenDetailedClass ? "detailed_view" : "" )}>
				{ !this.props.parentComponent &&
					<MarketplaceHeader updateStateFromChild={this.updateStateFromChild} chosenMenu={this.state.chosenMenu} showOptions={true}></MarketplaceHeader>
				}
				<div className={"marketplace_main " + (this.state.chosenMenu == 'My Profile' ? "noTopPadd" : "" ) + (this.props.parentComponent && this.props.parentComponent == 'marketplaceglobal' ? "fullWH" : "")}>
					{ !this.props.parentComponent &&
						<LoggedUser
							updateAllProfileData = {this.updateAllProfileData}
							ref={this.refMyUser}>
						</LoggedUser>
					}
					<div className={"main_market_title " + ( (this.state.isOpenDetailedClass || this.state.chosenMenu == 'My Profile') ? "d-none" : "" )}>{this.state.chosenMenu}</div>
					<div className={"back_class_container " + ( (!this.state.isOpenDetailedClass || this.state.chosenMenu !== 'Classes' ) ? "d-none" : "" )}>
						<div className="arrow_back_content" onClick={this.closeDetails}>
							<div className="back_icon"></div>
							<div className="back_title">Back</div>
						</div>
					</div>
					<div className={( this.state.chosenMenu !== 'Classes' ? "d-none" : "" )}>
						<div className={( this.state.isOpenDetailedClass ? "d-none" : "" )}>
							{ !this.props.parentComponent &&
								<SessionMenu 
								updateStateFromChild={this.updateStateFromChild} 
								ref={this.refMyMenu}
								chosenClassesMenu={this.state.chosenClassesMenu} 
								parentComponent='mainPage'
								></SessionMenu>
							}
							<div className="submenu_container">
								<div className="submenu_title">{this.state.chosenClassesMenu}</div>
							</div>
						</div>
						<div className={( (this.state.chosenClassesMenu !== 'Live' || (!this.state.currentUserData.showLiveAndOnDemand && !this.props.parentComponent)) ? "d-none" : "" )}>
							<MarketplaceLive 
							state={this.state}
							updateStateFromChild={this.updateStateFromChild} 
							isOpenDetailedClass={this.state.isOpenDetailedClass} 
							closeDetails={this.closeDetails}
							parentComponent='mainPage'
							history={this.props.history}
							ref={this.myRefLive}
							openWithoutToken={this.props.parentComponent}
							></MarketplaceLive>
						</div>
						<div className={( (this.state.chosenClassesMenu !== 'On-demand' || !this.state.currentUserData.showLiveAndOnDemand ) ? "d-none" : "" )}>
							{ !this.props.parentComponent &&
								<MarketplaceOnDemand 
								state={this.state}
								updateStateFromChild={this.updateStateFromChild} 
								isOpenDetailedClass={this.state.isOpenDetailedClass}
								parentComponent='mainPage'
								history={this.props.history}
								ref={this.myRefOnDemand}
								></MarketplaceOnDemand>
							}
						</div>
						<div className={( this.state.chosenClassesMenu !== 'Programs' ? "d-none" : "" )}>
							{ !this.props.parentComponent &&
								<MarketplacePrograms 
									state={this.state}
									updateStateFromChild={this.updateStateFromChild} 
									isOpenDetailedClass={this.state.isOpenDetailedClass}
									parentComponent='mainPage'
									history={this.props.history}
									ref={this.myRefPrograms}
								></MarketplacePrograms>
							}
						</div>
						<div className={( this.state.chosenClassesMenu !== 'My schedule' ? "d-none" : "" )}>
							{ !this.props.parentComponent &&
								<MarketplaceMySchedule 
									state={this.state}
									updateStateFromChild={this.updateStateFromChild} 
									isOpenDetailedClass={this.state.isOpenDetailedClass} 
									closeDetails={this.closeDetails}
									history={this.props.history}
									ref={this.myRefSchedule}
									searchFromMySchedule={this.searchFromMySchedule}
								></MarketplaceMySchedule>
							}
						</div>
						<div className={( this.state.chosenClassesMenu !== 'Challenges' ? "d-none" : "" )}>
							{ !this.props.parentComponent &&
								<MarketplaceChallenges 
									state={this.state}
									updateStateFromChild={this.updateStateFromChild} 
									isOpenDetailedClass={this.state.isOpenDetailedClass}
									parentComponent='mainPage'
									history={this.props.history}
									ref={this.myRefChallenges}
								></MarketplaceChallenges>
							}
						</div>
					</div>
					<div className={( this.state.chosenMenu !== 'Settings' ? "d-none" : "" )}>
						{ !this.props.parentComponent &&
							<SettingsPage ref={this.refSettings}></SettingsPage>
						}
					</div>
					<div className={( this.state.chosenMenu !== 'My Profile' ? "d-none" : "" )}>
						{ !this.props.parentComponent &&
							<MarketplaceMyProfile
								state={this.state}
								updateStateFromChild={this.updateStateFromChild} 
								ref={this.myRefProfile}
							></MarketplaceMyProfile>
						}
					</div>
				</div>
			</div>
			{this.state.failedPaymentStatus &&
				<div className="booked_pop_content">
					<div className="booked_container failedPaymentsWidth">
						<div className="booked_title failedText">Oops {this.state.currentUserData.firstName}, we sent you an email regarding an issue with your Virdio membership, we know you are busy and might have missed it or it went to your spam folder.</div>
						<div className="booked_title failedText">You can click on the link in your email or go to the Virdio website using your browser and login.</div>
						<div className="booked_title failedText">Thank you, Team Virdio.</div>
					</div>
				</div>
			} 
			{ this.state.showLoader && <MainLoader></MainLoader> }
			{ !this.props.parentComponent || (this.props.parentComponent && this.props.parentComponent != 'marketplaceglobal') &&
			 <SupportContainer supportPageName={this.state.supportPageName} supportPageApi={this.state.supportPageApi} userTypeFaqs={this.state.userTypeFaqs}></SupportContainer>
			}
		</div>
    );
  }
}
export default MarketplaceDashboard;
